import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class TaskServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(campaign_id, params = {}) {
    if (campaign_id !== null) {
      return this.http.get(`${campaign_id}/tasks`, { params: params });
    }
  }

  createItem(campaign_id, params = {}) {
    return this.http.post(`${campaign_id}/tasks`, params);
  }

  removeItem(campaign_id, task_id) {
    return this.http.delete(`${campaign_id}/tasks/${task_id}`);
  }

  editItem(campaign_id, task_id, params = {}) {
    return this.http.put(`${campaign_id}/tasks/${task_id}`, params);
  }

  removeItemModal({ campaign_id, task_id }) {
    return this.removeItem(campaign_id, task_id);
  }

  upload(campaign_id, file) {
    return this.http.post(`${campaign_id}/tasks/import`, file);
  }

  downloadTemplates() {
    return this.pure_http.get(`templates/tasks`);
  }
}

export const TaskService = new TaskServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'campaigns'
});
